import React, {Component} from 'react'

class Help001 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />初めて見積書を作成し保存する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[1-1]</span>画面上部のメニューの中の「見積書」(図1-1 参照)をクリックし、「見積書作成」をクリックしてください。</legend>
              <figcaption>図1-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_1-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[1-2]</span>画面の中の「白紙状態から新規作成」ボタン(図1-2 参照)を押してください。</legend>
              <figcaption>図1-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_1-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[1-3]</span>「見積書カテゴリー」を選択し、「見積書の名称」を入力し「保存」ボタンを押してください。(図1-3 参照)</legend>
              <figcaption>図1-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_1-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[1-4]</span>メッセージが表示されるので「OK」ボタンを押してください。(図1-4 参照)</legend>
              <figcaption>図1-4</figcaption>
              <ul>
                <li><img alt='' src='/help/help_1-4.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[1-5]</span>新しく見積書が作成されました。<br />必要事項を編集し、最後の「この見積書の内容を保存する」ボタンをクリックしてください。(図1-5 参照)</legend>
              <figcaption>図1-5</figcaption>
              <ul>
                <li><img alt='' src='/help/help_1-5.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help001



// WEBPACK FOOTER //
// ./src/help/Help001.js